import { Map } from 'immutable';
import { State } from 'flow/types/State';
import { ExtensionKey } from 'flow/types/EntityKeys';

// AI Coworker call records are now stored in the canonical call-records
// store. An AI agent is just an extension, so its sorting/pagination data
// lives under sortingData.extensions[extensionKey] alongside the personal
// extension's; entities live in callRecords[key]. Single-record lookups
// go through selectCallRecordFromKey in call-records-selectors.

const selectAgentAllSlice = (state: State, extensionKey: ExtensionKey) =>
    state.callRecordsData.getIn(
        ['sortingData', 'extensions', extensionKey, 'all'],
        Map(),
    );

export const selectGeneralSortingDataForExtension = (
    state: State,
    extensionKey: ExtensionKey,
) => selectAgentAllSlice(state, extensionKey).get('entries', Map());

export const selectGeneralNextBeforeForExtension = (
    state: State,
    extensionKey: ExtensionKey,
) => selectAgentAllSlice(state, extensionKey).get('nextBefore');
